import type { ReactNode, Ref } from 'react'

export interface AuthFormProps {
    onSubmit?: () => void
    formRef?: Ref<HTMLFormElement>
    children: ReactNode
}

const AuthForm = ({ onSubmit, formRef, children }: AuthFormProps) => {
    if (!onSubmit) {
        return <>{children}</>
    }

    return (
        <form
            ref={formRef}
            autoComplete="on"
            onSubmit={(e) => {
                e.preventDefault()
                onSubmit()
            }}
            style={{ display: 'contents' }}
        >
            {children}
            <button type="submit" hidden aria-hidden="true" tabIndex={-1} />
        </form>
    )
}

export default AuthForm
